var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookConsultationArrow = function SvgBookConsultationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.463 1.537 3.914 5 .463 8.463 2 10l5-5-5-5z"
  })));
};
export { SvgBookConsultationArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDcgMTAiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTAuNDYyNjQgMS41MzczNkwzLjkxNDM4IDVMMC40NjI2NDIgOC40NjI2NEwyIDEwTDcgNUwyIDQuMzcxMTRlLTA3TDAuNDYyNjQgMS41MzczNloiIC8+Cjwvc3ZnPgo=";